<template>
    <div id="summary">
        <h5>Resumen</h5>
        <div class="row row-products" v-for="(product, index) in cartGetItems" :key="index + '-' + product" >
            <product-in-cart :product-id="product" :index-in-cart="index" :view-only="true"/>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import productInCart from '../daniel/product-in-cart.vue'
export default {
    name: 'summary',
	components: { productInCart },
    computed: {
        ...mapGetters(['cartGetItems'])
    },
}
</script>

<style lang="less">
 #summary {

 }
</style>